import Vue from "vue";
import Router from "vue-router";
import ChangePassword from "../components/ChangePassword";
import * as CONSTANTS from "../store/constants";

Vue.use(Router);
export default new Router({
    mode: 'history',
    routes: [
        {
            path: CONSTANTS.ADS_DOMAIN_PATH,
            name: "ChangePassword",
            component: ChangePassword,
            meta: {
                domain: CONSTANTS.ADS_DOMAIN
            }
        }
    ]
});